// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: yksgp5L1Vgfi
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateOnMutateForSpec,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  initializeCodeComponentStates,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { AntdInput } from "@plasmicpkgs/antd5/skinny/registerInput";
import { inputHelpers as AntdInput_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput";
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDeveloperModal.module.css"; // plasmic-import: yksgp5L1Vgfi/css

createPlasmicElementProxy;

export const PlasmicDeveloperModal__VariantProps = new Array();

export const PlasmicDeveloperModal__ArgProps = new Array();

const $$ = {};

function PlasmicDeveloperModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "devClientKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "devWebHookKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "clientKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "webHookKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: generateOnMutateForSpec("value", AntdInput_Helpers)
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__baw3W)}>
        <div className={classNames(projectcss.all, sty.freeBox__yhBnM)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__hucix
            )}
          >
            <React.Fragment>
              <React.Fragment>{""}</React.Fragment>
              {
                <h6
                  className={classNames(
                    projectcss.all,
                    projectcss.h6,
                    projectcss.__wab_text,
                    sty.h6__ezaNr
                  )}
                >
                  {"For Production"}
                </h6>
              }

              <React.Fragment>{""}</React.Fragment>
            </React.Fragment>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__lIdck)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__l6XR
            )}
          >
            {"Add WebHook Client Key"}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__ef3V)}>
          {(() => {
            const child$Props = {
              className: classNames("__wab_instance", sty.clientKey),
              onChange: async (...eventArgs) => {
                generateStateOnChangePropForCodeComponents(
                  $state,
                  "value",
                  ["clientKey", "value"],
                  AntdInput_Helpers
                ).apply(null, eventArgs);
              },
              placeholder: "Enter WebHook Client Key",
              value: generateStateValueProp($state, ["clientKey", "value"])
            };
            initializeCodeComponentStates(
              $state,
              [
                {
                  name: "value",
                  plasmicStateName: "clientKey.value"
                }
              ],

              [],
              AntdInput_Helpers ?? {},
              child$Props
            );
            return (
              <AntdInput
                data-plasmic-name={"clientKey"}
                data-plasmic-override={overrides.clientKey}
                {...child$Props}
              />
            );
          })()}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__qVfjp)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___6DQ06
            )}
          >
            {"Add WebHook Url"}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__ybu55)}>
          {(() => {
            const child$Props = {
              className: classNames("__wab_instance", sty.webHookKey),
              onChange: async (...eventArgs) => {
                generateStateOnChangePropForCodeComponents(
                  $state,
                  "value",
                  ["webHookKey", "value"],
                  AntdInput_Helpers
                ).apply(null, eventArgs);
              },
              placeholder: "Enter WebHook Url",
              value: generateStateValueProp($state, ["webHookKey", "value"])
            };
            initializeCodeComponentStates(
              $state,
              [
                {
                  name: "value",
                  plasmicStateName: "webHookKey.value"
                }
              ],

              [],
              AntdInput_Helpers ?? {},
              child$Props
            );
            return (
              <AntdInput
                data-plasmic-name={"webHookKey"}
                data-plasmic-override={overrides.webHookKey}
                {...child$Props}
              />
            );
          })()}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__goqOu)}>
        <div className={classNames(projectcss.all, sty.freeBox__iIcF)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__u3Pwg
            )}
          >
            <React.Fragment>
              <React.Fragment>{""}</React.Fragment>
              {
                <h6
                  className={classNames(
                    projectcss.all,
                    projectcss.h6,
                    projectcss.__wab_text,
                    sty.h6__v6UZ7
                  )}
                >
                  {"For Development"}
                </h6>
              }

              <React.Fragment>{""}</React.Fragment>
            </React.Fragment>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__cdU2E)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__nSy2K
            )}
          >
            {"Add WebHook Client Key"}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox___98Rhw)}>
          {(() => {
            const child$Props = {
              className: classNames("__wab_instance", sty.devClientKey),
              onChange: async (...eventArgs) => {
                generateStateOnChangePropForCodeComponents(
                  $state,
                  "value",
                  ["devClientKey", "value"],
                  AntdInput_Helpers
                ).apply(null, eventArgs);
              },
              placeholder: "Enter WebHook Client Key",
              value: generateStateValueProp($state, ["devClientKey", "value"])
            };
            initializeCodeComponentStates(
              $state,
              [
                {
                  name: "value",
                  plasmicStateName: "devClientKey.value"
                }
              ],

              [],
              AntdInput_Helpers ?? {},
              child$Props
            );
            return (
              <AntdInput
                data-plasmic-name={"devClientKey"}
                data-plasmic-override={overrides.devClientKey}
                {...child$Props}
              />
            );
          })()}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__mf1Ll)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__jktoe
            )}
          >
            {"Add WebHook Url"}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__ziv1)}>
          {(() => {
            const child$Props = {
              className: classNames("__wab_instance", sty.devWebHookKey),
              onChange: async (...eventArgs) => {
                generateStateOnChangePropForCodeComponents(
                  $state,
                  "value",
                  ["devWebHookKey", "value"],
                  AntdInput_Helpers
                ).apply(null, eventArgs);
              },
              placeholder: "Enter WebHook Url",
              value: generateStateValueProp($state, ["devWebHookKey", "value"])
            };
            initializeCodeComponentStates(
              $state,
              [
                {
                  name: "value",
                  plasmicStateName: "devWebHookKey.value"
                }
              ],

              [],
              AntdInput_Helpers ?? {},
              child$Props
            );
            return (
              <AntdInput
                data-plasmic-name={"devWebHookKey"}
                data-plasmic-override={overrides.devWebHookKey}
                {...child$Props}
              />
            );
          })()}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__llpIj)}>
        <Button
          data-plasmic-name={"saveBtn"}
          data-plasmic-override={overrides.saveBtn}
          className={classNames("__wab_instance", sty.saveBtn)}
        >
          {"Save"}
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "clientKey",
    "webHookKey",
    "devClientKey",
    "devWebHookKey",
    "saveBtn"
  ],

  clientKey: ["clientKey"],
  webHookKey: ["webHookKey"],
  devClientKey: ["devClientKey"],
  devWebHookKey: ["devWebHookKey"],
  saveBtn: ["saveBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDeveloperModal__ArgProps,
          internalVariantPropNames: PlasmicDeveloperModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDeveloperModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDeveloperModal";
  } else {
    func.displayName = `PlasmicDeveloperModal.${nodeName}`;
  }
  return func;
}

export const PlasmicDeveloperModal = Object.assign(
  // Top-level PlasmicDeveloperModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    clientKey: makeNodeComponent("clientKey"),
    webHookKey: makeNodeComponent("webHookKey"),
    devClientKey: makeNodeComponent("devClientKey"),
    devWebHookKey: makeNodeComponent("devWebHookKey"),
    saveBtn: makeNodeComponent("saveBtn"),
    // Metadata about props expected for PlasmicDeveloperModal
    internalVariantProps: PlasmicDeveloperModal__VariantProps,
    internalArgProps: PlasmicDeveloperModal__ArgProps
  }
);

export default PlasmicDeveloperModal;
/* prettier-ignore-end */
